// extracted by mini-css-extract-plugin
module.exports = {"division":"Division_division__3CqpO","title":"Division_title__3WjeA"};